import { appendCdnToImagePath } from '../../common/utils/appendCdnToImagePath';
import BannerStyles from '../styles/banner';
import React, { useLayoutEffect, useState } from 'react';
import { Box } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { useBasicDetails } from '../../store';

/** Props for Banner */
type BannerProps = {
  src: string;
  alt: string;
};

/** Component for Banner Image */
const Banner: React.FC<BannerProps> = (props: BannerProps): JSX.Element => {
  const { src, alt = '' } = props;
  const {
    template: {
      settings: {
        page: { flexibleBanner },
      },
    },
  } = useBasicDetails();
  const [loading, setLoading] = useState(false);
  const classes = BannerStyles({ flexibleBanner });
  const imageSrc = src ? appendCdnToImagePath(src) : '';

  const handleImage = (): void => {
    setLoading(false);
  };

  /** used in order to set loader true before the image src is added in the DOM */
  useLayoutEffect(() => {
    setLoading(true);
  }, [src]);

  const BannerImage = (): JSX.Element => (
    <img
      onLoad={handleImage}
      onError={handleImage}
      className={loading ? classes.hidden : classes.media}
      src={imageSrc}
      alt={alt}
    />
  );

  if (flexibleBanner) {
    return (
      <>
        {loading && <Skeleton className={classes.fixedHeightWrapper} variant="rect" animation="wave" />}
        <BannerImage />
      </>
    );
  }

  return (
    <Box className={classes.fixedHeightWrapper} data-testid="bannerWrapper">
      {loading && <Skeleton variant="rect" animation="wave" height={'100%'} />}
      <BannerImage />
    </Box>
  );
};

export default React.memo(Banner);
